// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"123":"6f0dda05","169":"6f0dda05","228":"6f0dda05","540":"3611520c","898":"6f0dda05"}[chunkId] + ".css";
};